import React, { useEffect, useState } from "react";
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  InputGroup,
  Input,
  Button,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";

import SalesReportService from "../../../services/OrderingServices/SalesReportService";
import { formatDate } from "../../../Components/Common/FormatDate";
import ReturnBill from "../component/ReturnBill";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const ReturnBillLogs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [pan, setPan] = useState("");
  const [touched, setTouched] = useState(false);
  const [filterText, setFilterText] = useState("");

  const isInvalid = touched && !remarks?.trim();

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Ref Sales Invoice No",
      selector: (row) => row.refSalesInvoiceNumber,
      sortable: true,
    },
    {
      name: "Return Invoice No",
      selector: (row) => row.returnInvoiceNumber,
      sortable: true,
    },
    {
      name: "Customer Pan",
      selector: (row) => row.customerPan,
      sortable: true,
    },
    {
      name: "Return Date",
      selector: (row) => formatDate(row.returnDate),
      sortable: true,
    },
    {
      name: "Discount(%)",
      selector: (row) => row.discountPercentage,
      sortable: true,
      right: true,
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      right: true,
    },
    {
      name: "Total",
      selector: (row) => row.grandTotal,
      sortable: true,
      right: true,
    },
  ];

  const fetchReturnBill = async () => {
    try {
      setLoading(true);
      const response = await SalesReportService.returnBillList();
      setData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching return bills:", error);
    }
  };

  useEffect(() => {
    fetchReturnBill();
  }, []);

  const filteredData = data.filter((item) => {
    const searchContext = `${item?.refSalesInvoiceNumber || ""} ${
      item?.returnInvoiceNumber || ""
    } ${item?.customerPan || ""}`.toLowerCase();
    return searchContext.includes(filterText.toLowerCase());
  });

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    toggleDeleteModal();
  };

  const handleReturn = async () => {
    if (!remarks?.trim()) {
      setTouched(true);
      return;
    }
    if (selectedItem) {
      try {
        await SalesReportService.returnBill({
          refSalesInvoiceNumber: selectedItem?.invoiceNumber,
          customerPan: pan,
          totalReturnAmount: selectedItem?.grandTotal,
          remarks: remarks,
        });
        fetchReturnBill();
        setRemarks("");
        setPan("");
        toast.success("Selected bill is returned successfully");
      } catch (error) {
        toast.error("Failed to return the bill");
      } finally {
        toggleDeleteModal();
        setSelectedItem(null);
      }
    }
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Return Bill List" pageTitle="Return Bill" />

        {/* Search */}
        <Row className="mb-2">
          <Col md={8} xs={12}>
            <InputGroup>
              <Input
                placeholder="Search by return invoice no, customer pan & ref sales invoice no"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </InputGroup>
          </Col>
        </Row>

        {/* Desktop Table */}
        <div className="d-none d-lg-block">
          <Card>
            <CardBody>
              <CustomDataTable
                responsive
                striped
                pagination
                fixedHeader
                persistTableHead
                progressPending={loading}
                customStyles={customStyles}
                progressComponent={
                  <div className="my-3 text-center">
                    <Triangle
                      visible={true}
                      height="80"
                      width="80"
                      color="#5B71B9"
                      ariaLabel="triangle-loading"
                    />
                    <h5 className="mt-1">Loading...</h5>
                  </div>
                }
                columns={columns}
                data={filteredData}
              />
            </CardBody>
          </Card>
        </div>

        {/* Mobile Cards */}
        <div className="d-block d-lg-none">
          {loading ? (
            <div className="d-flex justify-content-center my-4">
              <Triangle visible={true} height="60" width="60" color="#5B71B9" />
            </div>
          ) : filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <Card key={item.returnInvoiceNumber} className="mb-2 shadow-sm">
                {/* <CardBody>
                  <div className="d-flex justify-content-between mb-1 ">
                    <strong>S.N:</strong> <span>{index + 1}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <strong>Ref Sales Invoice No:</strong>{" "}
                    <span>{item.refSalesInvoiceNumber}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <strong>Return Invoice No:</strong>{" "}
                    <span>{item.returnInvoiceNumber}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <strong>Customer Pan:</strong>{" "}
                    <span>{item.customerPan}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <strong>Return Date:</strong>{" "}
                    <span>{formatDate(item.returnDate)}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <strong>Discount(%):</strong>{" "}
                    <span>{item.discountPercentage}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <strong>Tax Amount:</strong> <span>{item.taxAmount}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <strong>Total:</strong> <span>{item.grandTotal}</span>
                  </div>
                  <div className="text-end mt-2">
                    <Button
                      size="sm"
                      color="danger"
                      onClick={() => handleDeleteClick(item)}
                    >
                      Return
                    </Button>
                  </div>
                </CardBody> */}
                <CardBody>
                  <div className="mb-2">
                    <strong>Invoice:</strong> {item.returnInvoiceNumber}{" "}
                    <span className="text-muted">
                      (Ref: {item.refSalesInvoiceNumber})
                    </span>
                  </div>
                  <div className="mb-2">
                    <strong>Customer Pan:</strong> {item.customerPan}
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <div>
                      <strong>Date:</strong> {formatDate(item.returnDate)}
                    </div>
                    <div>
                      <strong>Discount:</strong> {item.discountPercentage}%
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div>
                      <strong>Tax:</strong> Rs. {item.taxAmount}
                    </div>
                    <div className="fw-bold">
                      <strong>Total:</strong> Rs. {item.grandTotal}
                    </div>
                  </div>
                  <div className="text-end">
                    {/* <Button
                      size="sm"
                      color="danger"
                      onClick={() => handleDeleteClick(item)}
                    >
                      Return
                    </Button> */}
                  </div>
                </CardBody>
              </Card>
            ))
          ) : (
            <div className="text-center py-3">
              <p className="text-muted mb-0">No return bills found.</p>
            </div>
          )}
        </div>

        {/* Return Modal */}
        <ReturnBill
          show={deleteModal}
          onDeleteClick={handleReturn}
          onCloseClick={toggleDeleteModal}
          selectedItem={selectedItem}
          setRemarks={setRemarks}
          setPan={setPan}
          pan={pan}
          remarks={remarks}
          isInvalid={isInvalid}
          setTouched={setTouched}
        />
      </div>
    </Container>
  );
};

export default ReturnBillLogs;
